import {Link} from 'react-router-dom';
import styled from 'styled-components';

const Wrap = styled.div`
	margin: 0 auto;
	max-width: 28rem;
	padding: 96px 0;
	text-align: center;
`;
const Code = styled.p`
	font-size: 36px;
	line-height: 40px;
	font-weight: 700;
	color: #cbd5e1;
	margin: 0;
`;
const Heading = styled.h1`
	margin: 16px 0 0;
	font-size: 20px;
	line-height: 28px;
	font-weight: 700;
	color: #1e293b;
`;
const Body = styled.p`
	margin: 8px 0 0;
	font: ${p => p.theme.ticketing.font.subheading2};
	color: #64748b;
`;
const BackLink = styled(Link)`
	margin-top: 24px;
	display: inline-block;
	border-radius: 4px;
	background: #1d4ed8;
	padding: 8px 16px;
	font: ${p => p.theme.ticketing.font.subheading2};
	color: #ffffff;
	text-decoration: none;
	&:hover {
		background: #1e40af;
	}
`;

export function TicketNotFound() {
	return (
		<Wrap>
			<Code>404</Code>
			<Heading>Ticket not found</Heading>
			<Body>The ticket you&apos;re looking for doesn&apos;t exist or you don&apos;t have access to it.</Body>
			<BackLink to="/tickets">Back to tickets</BackLink>
		</Wrap>
	);
}
